import React from 'react';
import { Button, Flex, useBreakpoint } from '@landr/maestro';
import { useAuthentication } from 'components/Authentication';

export const AuthButtons: React.FC<{ loginLabel: string, signupLabel: string, hideLogin?: boolean }> = ({ loginLabel, signupLabel, hideLogin }) => {
    const { signupUrl, loginUrl } = useAuthentication();
    const isMobile = useBreakpoint('lg');

    return (
        <Flex flexWrap={"wrap"} sx={{ gap: "sm" }}>
            {
                !hideLogin &&
                <Button
                    as="a"
                    variant="secondary"
                    size={isMobile ? 'sm' : 'md'}
                    href={loginUrl}
                    isRounded
                >
                    {loginLabel}
                </Button>
            }

            <Button
                as="a"
                variant="primary"
                size={isMobile ? 'sm' : 'md'}
                href={signupUrl}
                isRounded
            >
                {signupLabel}
            </Button>
        </Flex>
    );
};
